import { memo } from "react"

import { BackButton } from "../../components/Buttons/BackButton"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const SubmitFormViewTopBar = memo(() => {
	return <BaseTopBar leftContent={<BackButton />} />
})
SubmitFormViewTopBar.displayName = "SubmitFormViewTopBar"
